export const RunAllWith = (fns: ((...args: any[]) => void)[], thisArg: any, ...args: any[]) =>
  fns.forEach(fn => fn.call(thisArg, ...args))
